import Vue from 'vue'
import ResponsivePlugin from '@/plugins/responsive'
import components from '@/plugins/components'
import Vuex from 'vuex'
import VeeValidate, { Validator } from 'vee-validate'
import VueSocialSharing from 'vue-social-sharing'
import Metrics from '@/plugins/metrics'

Vue.use(Vuex)
Vue.use(ResponsivePlugin)
Vue.use(VeeValidate)
Vue.use(VueSocialSharing)
Vue.use(Metrics)

Validator.extend('checked', {
  validate (value) {
    return value === true
  }
})

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})
